import {connect} from 'react-redux';
import {TimelineState} from 'VideoAudioQC/Timeline/Redux/TimelineReducer';
import {toggleSelectedMarkerAction} from 'VideoAudioQC/Timeline/Redux/TimelineActions';
import QCTabsContainer from './QCTabsContainer';
import {QCTabsState} from './Redux/QCTabsReducer';
import {setActiveTabAction} from './Redux/QCTabsActions';
import {TabIndex} from './QCTabsTypes';

export interface TabsState {
    timeline: {
        selectedMarker: TimelineState;
    },
    videoAudioQC: {
        qcTabs: QCTabsState
    };
}

export interface StateProps {
    activeTab: TabIndex;
    selectedRowId: string;
    selectedMarkerId: string;
}

export const mapState = (state: TabsState): StateProps => {
    const {
        timeline,
        videoAudioQC,
    } = state;
    const {activeTab} = videoAudioQC.qcTabs;
    const {selectedMarker} = timeline;
    
    return {
        activeTab,
        selectedRowId: selectedMarker.selectedRowId,
        selectedMarkerId: selectedMarker.selectedMarkerId,
    };
};

export const mapDispatch = {
    setActiveQCTab: setActiveTabAction,
    toggleSelectedMarker: toggleSelectedMarkerAction,
};

export default connect(mapState, mapDispatch)(QCTabsContainer);
